import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from '@api/core';
import { PatientConsultation, PatientConsultationData } from './patient-consultation.model';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environment/environment';
import { catchError, tap } from 'rxjs/operators';

const API_URL = 'medical_consultation';
const API_URL_CONSULTATION = 'medical_consultation_data';
const API_PREVIUS_CONSULTATION = 'previus_medical_consultation';

@Injectable({
  providedIn: 'root'
})
export class PatientConsultationApiService {
  constructor(private api: ApiService, private http: HttpClient) { }

  post(consultation: PatientConsultation): Observable<any> {
    return this.api.post(API_URL, '/', consultation);
  }

  private getUrl(api: string): string {
    return environment.api[api];
  }

  createMedicalConsultation(consultation: PatientConsultation, creatorId: number): Observable<any> {
    let url = `?creatorId=${creatorId}`;
    return this.api.post(API_PREVIUS_CONSULTATION, url, consultation);
  }

  put(medicalConsultatioId: number, consultation: PatientConsultation): Observable<any> {
    return this.api.put(API_URL, `/${medicalConsultatioId}`, consultation);
  }

  getBasicMedicalConsultationData(instituteId: string, patientId: number): Observable<any> {
    let params = `?instituteId=${instituteId}&patientId=${patientId}`;
    return this.api.get(API_URL_CONSULTATION, params);
  }

  getCurrentConsultation(patientId: string): Observable<any> {
    return this.api.get(API_URL, `/current?patientId=${patientId}`);
  }

  // Método para obtener headers de forma segura
  private getAuthHeaders(): HttpHeaders {
    try {
      const loginResponse = JSON.parse(sessionStorage.getItem('login_response') || '{}');
      const userDetails = loginResponse?.userDetails;

      if (!userDetails) {
        console.error('No user details found in session storage');
        return new HttpHeaders({
          'Content-Type': 'application/json'
        });
      }

      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      return new HttpHeaders({
        'X-Timezone': timeZone || 'UTC',
        'X-Account-Id': userDetails.id_account?.toString() || '',
        'X-User-Email': userDetails.email || '',
        'X-Professional-Id': userDetails.id_person?.toString() || '',
        'Content-Type': 'application/json'
      });
    } catch (error) {
      console.error('Error parsing session storage:', error);
      return new HttpHeaders({
        'Content-Type': 'application/json'
      });
    }
  }

  getPeriodConsultation(
    patientId: number,
    fechaDesde?: string,
    fechaHasta?: string,
    page: number = 0,
    size: number = 10
  ): Observable<PatientConsultationData[]> {

    // Validar parámetros de entrada
    if (!patientId || patientId <= 0) {
      console.error('Invalid patientId:', patientId);
      return of([]);
    }

    // Construir URL base
    let url = `${this.getUrl(API_PREVIUS_CONSULTATION)}?patientId=${patientId}&size=${size}&page=${page}`;

    // Agregar fechas solo si son válidas
    if (fechaDesde && fechaDesde !== 'Invalid date' && fechaDesde.trim() !== '') {
      url += `&sinceDate=${fechaDesde}`;
    }

    if (fechaHasta && fechaHasta !== 'Invalid date' && fechaHasta.trim() !== '') {
      url += `&toDate=${fechaHasta}`;
    }


    const headers = this.getAuthHeaders();
    const options = { headers };

    return this.http.get<PatientConsultationData[]>(url, options).pipe(
      tap((data) => {
        // Aquí puedes manejar los datos recibidos si es necesario
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching consultations:');
        console.error('Status:', error.status);
        console.error('Status Text:', error.statusText);
        console.error('Error message:', error.message);

        // Log más detallado del error
        if (error.error) {
          console.error('Error details:', error.error);
        }

        // Verificar diferentes tipos de errores
        if (error.status === 0) {
          console.error('Network error or CORS issue');
        } else if (error.status === 401) {
          console.error('Unauthorized - check authentication');
        } else if (error.status === 403) {
          console.error('Forbidden - check permissions');
        } else if (error.status === 404) {
          console.error('Endpoint not found');
        } else if (error.status >= 500) {
          console.error('Server error');
        }

        // Retornar array vacío en caso de error
        return of([]);
      })
    );
  }

  getConsultationByEvaluation(evaluationId: number): Observable<any> {
    return this.api.get(API_URL, `/evaluation?evaluationId=${evaluationId}`);
  }
}
